<igo-share-map [map]="map" />
